import type { AppRoute } from '../routes';

// Original decorative line icons; the adjacent route label names each link.
const paths: Record<AppRoute, string> = {
  overview: 'M3 3h7v7H3z M14 3h7v7h-7z M3 14h7v7H3z M14 14h7v7h-7z',
  organisations: 'M4 21V7l8-4v18 M12 9h8v12 M2 21h20 M7 8v1 M7 12v1 M7 16v1 M16 12v1 M16 16v1',
  pipeline: 'M4 4h16l-6 7v7l-4 2v-9z',
  reports: 'M4 3v18h17 M8 16v-5 M13 16V7 M18 16v-8',
  opportunities: 'M3 7h18v14H3z M8 7V3h8v4 M3 12h18 M10 12v3h4v-3',
  tasks: 'M9 3h6v4H9z M9 5H5v16h14V5h-4 M8 13l2 2 6-6 M8 18h8',
  catalogue: 'M3 4h7l2 2 2-2h7v16h-7l-2 2-2-2H3z M12 6v16 M6 9h3 M15 9h3 M6 13h3 M15 13h3',
  team: 'M9 3a3 3 0 1 0 0 6 3 3 0 0 0 0-6 M2 21v-4a7 7 0 0 1 14 0v4 M17 4a3 3 0 0 1 0 6 M19 13a5 5 0 0 1 3 4v4',
  onboarding: 'M3 12h12 M11 8l4 4-4 4 M7 6V3h14v18H7v-3',
  xero: 'M8 8h8v8H8z M8 3H3v5 M16 3h5v5 M21 16v5h-5 M8 21H3v-5',
  migration: 'M12 3v12 M8 7l4-4 4 4 M4 12v9h16v-9 M8 17h8',
  audit: 'M5 3h10l4 4v14H5z M15 3v4h4 M9 11h6 M9 15h6 M9 18h4',
  administration: 'M12 3l8 3v6c0 4-3 7-8 9-5-2-8-5-8-9V6z M9 12l2 2 4-4',
};

export function NavigationIcon({ route }: { route: AppRoute }) {
  return (
    <svg
      className="navigation-link-icon"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d={paths[route]} />
    </svg>
  );
}
